/* The version line along the foot of every page.
 *
 * ── WHERE THE NUMBER COMES FROM ──
 * package.json, not a constant of its own. A version kept in two places is a version
 * that disagrees with itself the first time somebody bumps one and forgets the other -
 * and the one people will bump is package.json, because that is what `npm version` and
 * the release tag already touch. Importing it here means the number on screen is the
 * number of the artefact that was built.
 *
 * (Create React App allows this one import from outside src/: its ModuleScopePlugin is
 * constructed with the app's package.json as an explicitly allowed file. Nothing else
 * outside src/ may be imported.)
 *
 * ── WHERE IT IS MOUNTED ──
 * Three places, which between them are every page:
 *   - DashboardView  — the signed-in shell, so every page inside it
 *   - AuthLayout     — login, forgotten password, OTP, new password
 *   - ReportHtmlView — the drill-down target, which has a layout of its own
 *
 * It is deliberately NOT inside a drill-down Modal or Side Panel: those render
 * HtmlReportWidgets directly rather than the ReportHtmlView page, so a dialog does not
 * end up with a copyright line across the bottom of it.
 */
import React from "react";
/* A NAMED import, not the default. Webpack treats a JSON module's keys as named
   exports and drops the ones nobody asked for, so the bundle carries the version
   string alone. Importing the default pulls the whole file in - the dependency list
   and its exact versions included, which is not something to publish for the sake of
   one number. */
import { version } from "../../../../package.json";
import "./appVersionFooter.css";

/* The year is read at render rather than written in, so the line does not quietly go
   stale in January. */
export default function AppVersionFooter({ className = "" }) {
  return (
    <footer className={`avf-bar${className ? ` ${className}` : ""}`}>
      Version {version}. Copyright © {new Date().getFullYear()} Ecologital. All rights reserved
    </footer>
  );
}
